import { render, staticRenderFns } from "./AppGardenCalendar.vue?vue&type=template&id=54fcba44&"
import script from "./AppGardenCalendar.vue?vue&type=script&lang=js&"
export * from "./AppGardenCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports